import { Controller } from "@hotwired/stimulus";
import { createPopper } from "@popperjs/core";

export default class extends Controller {
  static targets = ["menu"];
  static values = {
    // Opt in to popper-based positioning with strategy: 'fixed'. Needed when
    // the trigger lives inside an `overflow: hidden` ancestor and the menu
    // would otherwise be clipped.
    popper: Boolean,
    placement: { type: String, default: "bottom-start" },
  };

  connect() {
    if (this.popperValue) {
      this.popper = createPopper(this.element, this.menuTarget, {
        placement: this.placementValue,
        strategy: "fixed",
        modifiers: [
          { name: "offset", options: { offset: [0, 5] } },
          { name: "flip", options: { rootBoundary: "viewport" } },
          { name: "preventOverflow", options: { rootBoundary: "viewport" } },
        ],
      });
    }
  }

  disconnect() {
    this.popper?.destroy();
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden");
    if (!this.menuTarget.classList.contains("hidden")) this.popper?.update();
  }

  forceHide() {
    this.menuTarget.classList.add("hidden");
  }

  hide(event) {
    // @ts-ignore
    if (
      !this.element.contains(event.target) &&
      !this.menuTarget.classList.contains("hidden")
    ) {
      this.menuTarget.classList.add("hidden");
    }
  }
}
